// this file added for individual by Bearer Web Developer
import { flow, getParentOfType, Instance, types } from "mobx-state-tree";
import { TCustomerRequestDeleteAccountData, TCustomerRequestDeleteAccountResponse } from "./models/customerRequestDeleteAccount";
import { getFunctions, httpsCallable } from "firebase/functions";
import { analytics, firebaseApp } from "../../api/bearer-api";
import { AppState, MessageEnum } from "../app-state";
import { TCustomerConfirmDeleteAccountData, TCustomerConfirmDeleteAccountResponse } from "./models/customerConfirmDeleteAccount";
import { getPublicip } from "../../app/getPublicip";
import { logEvent } from "firebase/analytics";
export enum ReasonForDeleteAccountEnum {
    TooHighCost = 'The cost of the service is too high',
    NotFitToTheJobs = 'The Bearers are not fit to the jobs',
    DelaysCompleted = 'Delays for having jobs completed',
    Others = 'Other reason',
}
export enum StepForDeleteAccountEnum {
    Request = 'Request delete account',
    Confirm = 'Confirm delete account',
}
export const DeleteAccountState = types
    .model("DeleteAccountState", {
        reason: types.maybeNull(types.enumeration([...Object.values(ReasonForDeleteAccountEnum)])),
        step: types.optional(types.maybeNull(types.frozen<StepForDeleteAccountEnum>()), StepForDeleteAccountEnum.Request),
        loading: types.optional(types.boolean, false),
        open: types.optional(types.boolean, false),
    })
    .actions(self => {
        return {
            setOpen(value: boolean) {
                self.open = value
            },
            setLoading(value: boolean) {
                self.loading = value
            },
            setReason(value: ReasonForDeleteAccountEnum) {
                self.reason = value;
            },
            setStep(value: StepForDeleteAccountEnum) {
                self.step = value;
            },
            requestDeleteAccount: async () => {
                try {
                    const data: TCustomerRequestDeleteAccountData = { delete_account_reason: self.reason || '' }
                    console.log({ data })
                    const functions = getFunctions(firebaseApp);
                    const t = httpsCallable<TCustomerRequestDeleteAccountData, TCustomerRequestDeleteAccountResponse>(functions, 'customerRequestDeleteAccount');
                    const result = await t(data);
                    console.log({ result })
                    return result?.data;
                } catch (err: any) {
                    console.error(err); // modify by Bearer Web Developer
                    console.error(err?.message || 'unknown error');   // throw new Error modified by Bearer Web Developer
                }
            },
            confirmDeleteAccount: async (otp: string) => {
                try {
                    const ip = await getPublicip();
                    if (!ip) {
                        console.log({ ip });
                        console.error('something went wrong in getting ip');
                        return;
                    }
                    const data: TCustomerConfirmDeleteAccountData = { token: otp, ip: ip }
                    console.log({ data })
                    const functions = getFunctions(firebaseApp);
                    const t = httpsCallable<TCustomerConfirmDeleteAccountData, TCustomerConfirmDeleteAccountResponse>(functions, 'customerConfirmDeleteAccount');
                    const result = await t(data);
                    console.log({ result })
                    return result?.data;
                } catch (err: any) {
                    console.error(err); // modify by Bearer Web Developer
                    console.error(err?.message || 'unknown error');   // throw new Error modified by Bearer Web Developer
                }
            },
        }
    }).actions(self => {
        return {
            customerRequestDeleteAccount: flow(function* () {
                try {
                    const result: TCustomerRequestDeleteAccountResponse = yield self.requestDeleteAccount();
                    console.log({ requestDeleteAccount_result: result });
                    if (result?.code === 200) {
                        return true;
                    } else if (result?.code === 401) {
                        const appState = getParentOfType(self, AppState);
                        appState.setErrorMessage({
                            message: result?.message || 'unknown error!', error: MessageEnum.Error401,
                        });
                    } else if (result?.code === 499) {
                        const appState = getParentOfType(self, AppState);
                        appState.setErrorMessage({
                            message: result?.message || 'unknown error!',
                            error: MessageEnum.Unknown,
                        });

                    } else if (result?.code === 500) {
                        const appState = getParentOfType(self, AppState);
                        appState.setErrorMessage({
                            message: result?.message || 'unknown error!', error: MessageEnum.ServerError
                        });
                    }
                } catch (error) {
                    console.error(error); // modify by Bearer Web Developer
                }
            }),
            customerConfirmDeleteAccount: flow(function* (otp: string) {
                try {
                    const result: TCustomerConfirmDeleteAccountResponse = yield self.confirmDeleteAccount(otp);
                    if (result?.code === 200 || result?.code === 400 || result?.code === 423) {
                        // Firebase Analytics Event Name Delete Account happened added by Bearer Web Developer start
                        // App Event customerConfirmDeleteAccount = code 200
                        if (result?.code === 200) {
                            logEvent(analytics,"delete_account_happened", {
                                reason: self.reason
                            })
                        }
                        // Firebase Analytics Event Name Delete Account happened added by Bearer Web Developer end
                        return result;
                    } else if (result?.code === 401) {
                        const appState = getParentOfType(self, AppState);
                        appState.setErrorMessage({
                            message: result?.message || 'unknown error!', error: MessageEnum.Error401,
                        });
                    } else if (result?.code === 499) {
                        const appState = getParentOfType(self, AppState);
                        appState.setErrorMessage({
                            message: result?.message || 'unknown error!',
                            error: MessageEnum.Unknown,
                        });

                    } else if (result?.code === 500) {
                        const appState = getParentOfType(self, AppState);
                        appState.setErrorMessage({
                            message: result?.message || 'unknown error!', error: MessageEnum.ServerError
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            })
        }
    })
export interface IDeleteAccountState extends Instance<typeof DeleteAccountState> { };

